<template>
  <vue-scroll>
    <div class="flex-column">
      <span class="description" v-for="(detail, idx) in rulesDetails.expressions" :key="idx">{{ detail }}</span>
    </div>
    <div>
      <span class="subtitle2">Rule ID</span>
      <span class="value">{{ rulesDetails.id }}</span>
    </div>
    <div>
      <span class="subtitle2">Type</span>
      <span class="value">{{ rulesDetails.type }}</span>
    </div>
    <div>
      <span class="subtitle2">Score</span>
      <span class="value">{{ rulesDetails.ruleScore }}</span>
    </div>
    <el-divider />
    <div>
      <span class="subtitle2">ATT&CK</span>
      <span class="value" v-if="rulesDetails.killChainData">
        <cyber-kill-chain-tick-chart :chart-id="`${rulesDetails.id}`" :chart-data="rulesDetails.killChainData" />
      </span>
    </div>
    <el-divider />
    <div>
      <span class="subtitle2">Tactic</span>
      <span class="value">
        <a :href="rulesDetails.externalTacticUrl" target="_blank" rel="noreferrer"
          >{{ rulesDetails.tactic }}: {{ rulesDetails.mitreAttackTactic ? rulesDetails.mitreAttackTactic.name : '' }}</a
        >
      </span>
    </div>
    <el-divider />
    <div>
      <span class="subtitle2">Technique</span>
      <span class="value">
        <a :href="rulesDetails.externalTechniqueUrl" target="_blank" rel="noreferrer"
          >{{ rulesDetails.technique }}:
          {{ rulesDetails.mitreAttackTechnique ? rulesDetails.mitreAttackTechnique.name : '' }}</a
        >
      </span>
    </div>
    <el-divider />
    <div>
      <span class="subtitle2">Status</span>
      <span class="value">
        <el-tag size="medium" :class="rulesDetails.enabled ? 'active-status' : 'inactive-status'">{{
          rulesDetails['enabledText']
        }}</el-tag>
      </span>
    </div>
  </vue-scroll>
</template>

<script>
import CyberKillChainTickChart from '@/components/chart/CyberKillChainTickChart.vue'

export default {
  name: 'RulesDetailsFeed',
  props: {
    rulesDetails: {
      default () {
        return {}
      },
      type: [Array, Object]
    }
  },
  components: { CyberKillChainTickChart }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/icon.css';

section {
  height: calc(100%-160px);
}

.flex-column {
  flex-direction: column;
}

div {
  display: flex;
  flex-wrap: nowrap;
  padding: 8px;

  &:first-of-type {
    border-top: 1px solid var(--border-color);
    margin-top: 10px;
    padding-top: 24px;
  }

  .value {
    flex-grow: 1;
    align-self: auto;
    max-width: 50%;
  }

  .subtitle2 {
    flex-grow: 1;
    align-self: auto;
    max-width: 27%;
    padding: 0px 0px 0px 20px;
    margin: 0px 16px 0px 0px;
  }

  .icon {
    background: none;
    margin: 0px 10px 0px 0px;
    font-size: 16px;
    color: var(--aluminum-600);
  }

  .icon-criticality {
    .icon {
      background: var(--aluminum-600);
      line-height: 24px;
      margin-top: 10px;
    }
  }

  .status_metadata {
    display: grid;
    margin: 16px 0px 0px 0px;
    line-height: 24px;
  }
}

.description {
  padding: 0px 0px 0px 20px;
  flex: 0 0 90%;
}

.el-divider {
  padding: 0px;
  margin: 0px;
}

.active-status {
  background-color: var(--shamrock-100);
  color: var(--shamrock-900);
  border-color: var(--shamrock-900);
}

.inactive-status {
  background-color: var(--aluminum-50);
  color: var(--aluminum-700);
  border-color: var(--aluminum-700);
}
</style>



// WEBPACK FOOTER //
// src/components/feed/RulesDetailsFeed.vue